exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dev[data-v-63c4d444]{text-align:center;color:#147fd1;font-size:14px}footer .column[data-v-63c4d444]{background:radial-gradient(circle farthest-corner at 200px 0,#00518f,#2196f3);-webkit-background-clip:text;-webkit-text-fill-color:transparent;-webkit-animation:1s fade-in-card ease;animation:1s fade-in-card ease}footer .column img[data-v-63c4d444]{width:60px}footer a[data-v-63c4d444]{background:radial-gradient(circle farthest-corner at 200px 0,#00518f,#2196f3);-webkit-background-clip:text;-webkit-text-fill-color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63c4d444","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/BaseFooter.vue
// module id = uHMT
// module chunks = 0